import './assets/trigger.css';
import { jsxs as _, jsx as r } from "react/jsx-runtime";
import { faAngleDown as a } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as l } from "@fortawesome/react-fontawesome";
import * as g from "@radix-ui/react-select";
import m from "clsx";
import { forwardRef as p } from "react";
const f = "_trigger_12cns_3", d = "_trigger_error_12cns_47", h = "_trigger_icon_12cns_63", u = "_trigger_value_12cns_69", e = {
  trigger: f,
  trigger_error: d,
  trigger_icon: h,
  trigger_value: u
}, x = p((o, i) => {
  const { className: t, hasError: s, placeholder: c, ...n } = o;
  return /* @__PURE__ */ _(
    g.Trigger,
    {
      ref: i,
      className: m(
        e.trigger,
        {
          [e.trigger_error]: s
        },
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ r("span", { className: e.trigger_value, children: /* @__PURE__ */ r(g.Value, { placeholder: c }) }),
        /* @__PURE__ */ r(g.Icon, { asChild: !0, children: /* @__PURE__ */ r(l, { icon: a, className: e.trigger_icon }) })
      ]
    }
  );
});
x.displayName = "Trigger";
export {
  x as Trigger
};
